<script setup lang="ts"></script>

<template>
  <div class="media-slider scrollbars">
    <slot />
  </div>
</template>

<style scoped lang="postcss">
.media-slider {
  @apply relative flex max-w-full snap-x space-x-3 overflow-x-auto overflow-y-visible py-0;
  overscroll-behavior-inline: contain;
  scroll-snap-type: inline mandatory;
  margin-bottom: calc(-1 * var(--scrollbar-width));
}
.scrollbars {
  --scrollbar-size: 10px;
  --scrollbar-fg: rgba(0, 0, 0, 0);
  --scrollbar-bg: rgba(0, 0, 0, 0);

  &:hover,
  &:active {
    --scrollbar-fg: rgba(0, 0, 0, 0.25);
  }

  &::-webkit-scrollbar {
    width: var(--scrollbar-size);
    height: var(--scrollbar-size);
  }
  &::-webkit-scrollbar-thumb {
    background: var(--scrollbar-fg);
    border-radius: var(--scrollbar-size);
  }
  &::-webkit-scrollbar-track {
    background: var(--scrollbar-bg);
  }
  scrollbar-color: var(--scrollbar-fg) var(--scrollbar-bg);
}
</style>
